<!-- Template for the action button that parent component can render -->
<ng-template #actionButton>
  <iris-button
    [type]="IrisButtonTypes.PRIMARY"
    (click)="reviewedCostEstimation()"
    data-test="next-button"
  >
    Next
  </iris-button>
</ng-template>

<mat-spinner
  *ngIf="isLoading$ | async"
  class="loading-spinner"
  diameter="24"
  aria-label="Loading cost estimation"
></mat-spinner>

<ng-container *ngIf="!(isLoading$ | async)">
  <div class="cost-estimation-container">
    <h1 class="cost-estimation-header" data-test="cost-estimation-header"ß>
      {{ sessionCovered ? "Great news!" : "We've verified your health insurance benefits" }}
    </h1>

    <p *ngIf="onlyPayCopay" data-test="only-pay-copay">
      Your health insurance covers therapy sessions so you'll only have a copay for each session.
    </p>

    <p *ngIf="benefitsInfo?.displayedClientCostEstimate === 0" data-test="fully-covered">
      Your health insurance fully covers therapy sessions.
    </p>

    <img
      class="cost-estimation-image"
      [src]="sessionCovered ? '/assets/billing/cost_estimation_illo_with_sparkle.svg' : '/assets/billing/cost_estimation_illo.svg'" 
      alt="Cost Estimation"
    >

    <h4 class="cost-estimate-label" data-test="cost-estimate-label">Estimated session cost:</h4>

    <!-- Hides cents in dollar amount if there aren't any -->
    <span class="cost-estimate-amount" data-test="cost-estimate-amount">
      {{ (benefitsInfo?.displayedClientCostEstimate ?? 0) % 1 !== 0 ? (benefitsInfo?.displayedClientCostEstimate | currency:'USD':'symbol':'1.2-2') : (benefitsInfo?.displayedClientCostEstimate | currency:'USD':'symbol':'1.0-0') }}
    </span>
  </div>

  <client-insurance-progress-stepper *ngIf="showInsurancePlanStepper" [benefitsInfo]="benefitsInfo">
  </client-insurance-progress-stepper>

  <client-cost-estimation-faq [benefitsInfo]="benefitsInfo">
  </client-cost-estimation-faq>

  <iris-button-container *ngIf="accountSetupType !== 'propose_a_time' && !fromDirectBooking" [alignment]="IrisButtonContainerAlignments.END">
    <ng-container *ngTemplateOutlet="actionButton"></ng-container>
  </iris-button-container>
</ng-container>
